// src/theme/icons.ts
// Semantic icon registry. Swapping a glyph anywhere is a one-line change
// here. Values are Ionicons names (@expo/vector-icons). No emoji as icons.
import type { Ionicons } from '@expo/vector-icons';

type IoniconName = keyof typeof Ionicons.glyphMap;

export const icons = {
  // tab bar
  build: 'construct-outline',
  buildActive: 'construct',
  discover: 'compass-outline',
  discoverActive: 'compass',
  myApps: 'phone-portrait-outline',
  myAppsActive: 'phone-portrait',
  // common
  add: 'add',
  chevron: 'chevron-forward',
  close: 'close',
  back: 'arrow-back',
  // project editor
  undo: 'arrow-undo',
  redo: 'arrow-redo',
  publish: 'cloud-upload-outline',
  published: 'cloud-done',
  editChat: 'chatbubble-ellipses-outline',
  editChatActive: 'chatbubble-ellipses',
  preview: 'play-outline',
  previewActive: 'play',
  code: 'code-slash-outline',
  codeActive: 'code-slash',
  assets: 'images-outline',
  assetsActive: 'images',
  // onboarding intent cards
  buildIntent: 'construct-outline',
  browseIntent: 'compass-outline',
  // account
  account: 'person-circle-outline',
  // The web's third tab (web/src/shell/TabBar.tsx), filled when it is the page on screen.
  accountActive: 'person-circle',
  password: 'key-outline',
  llmSettings: 'options-outline',
  signOut: 'log-out-outline',
  delete: 'trash-outline',
  // empty states
  emptyApps: 'sparkles-outline',
} as const satisfies Record<string, IoniconName>;

export type IconName = keyof typeof icons;
